<template>
  <section class="section_flex">
    <a-row class="controls">
      <a-col>
        <a-form layout="inline" class="form">
          <TableControlsSkeleton :count="countFilterLoading" width="200px" v-if="countLoading == 0" style="margin-right: 20px"/>

          <div class="all__contact" v-show="countLoading > 0">
            
            <a-form-item>
              <a-tooltip>
                <template #title> Busca por nombre, código, teléfono, nombre de usuario o identificador de WhatsApp </template>
                <a-input v-model:value="search" placeholder="Buscar contacto" class="form__input">
                  <template #prefix>
                    <SearchOutlined />
                  </template>
                </a-input>
              </a-tooltip>
            </a-form-item>
            <entity-picker
              class="container__picker"
              v-if="user?.customer?.type_business == 1"
              :value="entity || 'Todas las empresas'"
              @update:value="entity = $event; campaign = 0;"
              @finishLoading="countLoading++"
            />

            <campaign-picker
              class="container__picker"
              :value="campaign"
              @update:value="campaign = $event"
              :entity="entity"
            />

            <div v-if="!hasHubspotActive" class="flex">
              <bases-picker
                class="container__picker"
                v-if="user?.customer?.enable_bases"
                :value="base"
                @update:value="base = $event"
                :entity="entity"
                :portfolio="campaign"
              />

              <managed-and-unmanaged-picker
                :value="coverage"
                @update:value="coverage = $event"
                class="container__picker"
              />

              <a-form-item :label="label">
                <a-select
                  v-model:value="status"
                  class="container__picker select"
                >
                  <a-select-option :key="''"> Activos e inactivos</a-select-option>
                  <a-select-option :key="1" value="1"> Activos </a-select-option>
                  <a-select-option :key="2" value="2"> Inactivos </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div v-else class="flex" style="margin-right: 13px;">
              <a-button @click="handleMoreFilters">
                Más filtros
              </a-button>
            </div>

            <a-form-item class="form-item__advanced-filter">
              <!-- <a-input
                type="button"
                value="Filtros avanzados"
                @click="handleOpenAdvanceFilter"
                class="cursor"
              >
                <template #prefix>
                  <ExclamationCircleOutlined />
                </template>
              </a-input> -->
              <a-tooltip>
                <template #title>
                  Filtros avanzados
                </template>
                <a-button @click="handleOpenAdvanceFilter">
                  <FilterOutlined />
                </a-button>
              </a-tooltip>
            </a-form-item>
          </div>
          
          
        </a-form>
      </a-col>
    </a-row>
    <div class="actions">
      <div v-if="loadingTableData" class="total tree-skeleton__bar"></div>
      <p class="total" v-else><strong>Contactos encontrados:</strong> {{ total }}</p>
      <a-tooltip placemente="bottom" v-if="hasHubspotActive">
        <template #title> 
          <span>
            Este módulo tiene permisos de HubSpot activos. <strong>Haz clic para conocer más.</strong>
          </span>
          <span v-if="false">
            Todos los nuevos contactos que se creen serán exportados automáticamente a HubSpot. 
            Para cambiar a manual, edita desde <span class="fake-link" @click="redirectIntegration" >Integraciones</span>.
          </span>
        </template>
        <a-dropdown :trigger="['click']" placement="bottomLeft" class="hs-select-dropdown" v-if="!isAgentUser">
          <!-- Botón estilo "select" -->
          <a-button class="hs-select" type="default">
            <span class="hs-select__left">
              <HubspotLogo class="hs-select__icon" />
              <DownOutlined class="hs-select__caret" />
            </span>
          </a-button>

          <!-- Menú -->
          <template #overlay>
            <a-menu class="hs-menu" @click="onMenuClick">
              <a-menu-item key="info" style="gap: 8px">
                <EyeOutlined class="hs-menu-item" />
                <span>Ver más información</span>
              </a-menu-item>

              <a-menu-item key="export">
                <ExportOutlined class="hs-menu-item" />
                <span>Exportar contactos</span>
              </a-menu-item>

              <a-menu-item key="import" v-if="hasHubspotImport">
                <ImportIcon class="menu-icon" />
                <span>Importar contactos</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </a-tooltip>
      <hubspot-events-popover in-progress v-if="hasHubspotActive" />
      <a-divider type="vertical" style="height: 2em" v-if="hasHubspotActive" />
      <a-tooltip>
        <template #title> Configura las columnas a mostrar </template>
        <a-button class="button create" @click="handleOpenColumnFilterDrawer">
          Columnas <table-outlined />
        </a-button>
      </a-tooltip>

      <a-button class="button create" type="primary" ghost @click="openCreateContactModal">
        Crear contacto
        <PlusOutlined />
      </a-button>

      <a-tooltip>
        <template #title>
          <span v-if="isGlobalDownloading">Tiene una descarga pendiente</span>
          <span v-else>
            Descarga contactos de acuerdo <br />
            a tu filtro aplicado.
          </span>
        </template>
        <a-button @click="handleDownload" :loading="downloading" :disabled="isGlobalDownloading || selectedRows.length > 0">
          <DownloadOutlined />
        </a-button>
      </a-tooltip>
    </div>
  </section>

  <CreateNewContact
    v-if="createContactModalVisible"
    :visible="createContactModalVisible"
    @update="handleSearch"
    @close="createContactModalVisible = false"
  />

  <div v-if="selectedRows.length !== 0" class="multiselect-row">
    <div class="counter">
      <LoadingOutlined v-if="loadingSelectMassive" />
      <span v-else>
        <template v-if="selectedRows.length === 1">
          Se ha seleccionado <strong>1 cliente</strong> de esta página.
        </template>
        <template v-else>
          Se han seleccionado <strong>{{ selectedRows.length }} clientes</strong>.
        </template>
        <template v-if="selectedRows.length >= 50 && selectedRows.length < total">
          <a-button type="link" style="padding: 4px 0;" @click="handleSelectedAll()">
            Seleccionar los {{ total }} clientes encontrados según tus filtros
          </a-button>
        </template>
        <a-divider
          type="vertical"
          class="divider"
          style="margin-right: 10px"
          v-if="selectedRows.length >= 50 && selectedRows.length < total && selectedTableRowKeys.length > 50"
        />
        <template v-if="selectedTableRowKeys.length > 50">
          <a-button type="link" style="padding-left: 0" @click="handleDeselectedAll()">
            Cancelar Selección
          </a-button>
        </template>
      </span>
    </div>

    <div class="actions">
      <a-button type="link" :disabled="countStatusSelected.inactives == 0 || getUserData?.profile == ProfileTypes.Agent" @click="showModalChangeStatus(1)"> Activar contactos </a-button>

      <a-divider type="vertical" class="divider" />

      <a-button type="link" :disabled="countStatusSelected.actives == 0 || getUserData?.profile == ProfileTypes.Agent" @click="showModalChangeStatus(2)"> Inactivar contactos </a-button>

      <a-divider type="vertical" class="divider" />

      <a-button type="link" @click="handleDownload" :loading="downloading"> Descargar contactos </a-button>

      <a-divider type="vertical" class="divider" v-if="hasHubspotExportManual" />

      <a-tooltip v-if="hasHubspotExportManual">
        <template #title>
          <span v-if="selectedHubspotExportRowKeys.length === 0">
            Los contactos seleccionados ya están sincronizados entre BeexCC y HubSpot.
          </span>
          <span v-else>
            {{ selectedHubspotExportRowKeys.length }} {{ selectedHubspotExportRowKeys.length === 1 ? "contacto" : "contactos" }} 
            seleccionados se pueden exportar a Hubspot.
          </span>
        </template>
        <a-button
          type="link"
          v-if="!isAgentUser"
          @click="handleConfirmExportHubspot"
          :disabled="selectedHubspotExportRowKeys.length === 0"
          :loading="downloading"
        >
          Exportar a Hubspot ({{ selectedHubspotExportRowKeys.length }})
          <HubspotIcon
            size="12"
            :color="selectedHubspotExportRowKeys.length === 0 ? '#00000040' : '#1677FF'"
            style="margin-left: 5px" 
          />
        </a-button>
      </a-tooltip>

      <a-divider type="vertical" class="divider" v-if="selectedHubspotResyncRowKeys.length > 0 && !isAgentUser && hasHubspotExportManual" />
      <a-tooltip v-if="selectedHubspotResyncRowKeys.length > 0 && !isAgentUser">
        <template #title>
          <span>
            {{ selectedHubspotResyncRowKeys.length }} {{ selectedHubspotResyncRowKeys.length === 1 ? "contacto" : "contactos" }} 
            seleccionados tienen datos por actualizar entre BeexCC y HubSpot.
          </span>
        </template>
        <a-button
          type="link"
          @click="handleConfirmExportHubspot"
          :disabled="selectedHubspotResyncRowKeys.length === 0"
          :loading="downloading"
        >
          Actualizar con Hubspot ({{ selectedHubspotResyncRowKeys.length }})
          <HubspotIcon
            size="12"
            :color="selectedHubspotResyncRowKeys.length === 0 ? '#00000040' : '#1677FF'"
            style="margin-left: 5px" 
          />
        </a-button>
      </a-tooltip>
    </div>

    <ChangeStatusContactModal
      v-if="visibleAlertInactiveContact"
      multipleContacts
      :count-contacts="selectedRows.length"
      :status="statusChange"
      @changeStatus="handleUpdateStatus(statusChange)"
      @onCancel="visibleAlertInactiveContact = false"
    />
  </div>

  <a-drawer
    :visible="visibleMoreFilters"
    title="Filtrar contactos"
    placement="right"
    width="480"
    keyboard
    :body-style="{ padding: 0 }"
    :maskClosable="false"
    @close="visibleMoreFilters = false"
  >
    <custom-scrollbar height="calc(100vh - 72px - 48px)">
      <div class="modal__body">
        <a-form layout="vertical">
          <entity-picker
            class="container__picker--drawer"
            v-if="user?.customer?.type_business == 1"
            label="Empresa"
            :value="formDrawer.entity || 'Todas las empresas'"
            @update:value="formDrawer.entity = $event; formDrawer.campaign = 0;"
          />

          <campaign-picker
            class="container__picker--drawer"
            label="Campaña"
            :value="formDrawer.campaign"
            @update:value="formDrawer.campaign = $event"
            :entity="formDrawer.entity"
          />

          <bases-picker
            class="container__picker--drawer"
            v-if="user?.customer?.enable_bases"
            label="Grupo de bases"
            :value="formDrawer.base"
            @update:value="formDrawer.base = $event"
            :entity="formDrawer.entity"
            :portfolio="formDrawer.campaign"
          />

          <managed-and-unmanaged-picker
            label="Gestion de contacto"
            :value="formDrawer.coverage"
            @update:value="formDrawer.coverage = $event"
            class="container__picker--drawer"
          />

          <a-form-item label="Estado" class="container__picker--drawer">
            <a-select
              v-model:value="formDrawer.status"
              class="select"
            >
              <a-select-option :key="''"> Activos e inactivos</a-select-option>
              <a-select-option :key="1" value="1"> Activos </a-select-option>
              <a-select-option :key="2" value="2"> Inactivos </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </div>
    </custom-scrollbar>

    <div class="footer">
      <a-button class="footer__button" @click="handleClearDrawer">
        Limpiar
      </a-button>
      <a-button type="primary" @click="handleApplyFilters">
        Aplicar
      </a-button>
    </div>
  </a-drawer>

  <HubspotEventModal
    v-if="eventModalVisibleImport"
    :visible="eventModalVisibleImport"
    @update:visible="eventModalVisibleImport = $event"
    :type="HubspotIntegrationType.Import"
    @save="handleEventSave"
  />

  <HubspotInfoExport
    v-if="eventModalVisibleExport"
    v-model:open="eventModalVisibleExport"
  />

  <HubspotManualModal
    v-if="eventModalVisibleInfo"
    v-model:open="eventModalVisibleInfo"
  />

  <HubspotExportConfirmModal 
    v-if="visibleConfirmExport" 
    :open="visibleConfirmExport" 
    :type="actionHubspot"
    :contactsIds="selectedHubspotExportIds" 
    :loadingSave="loadingSaveHubspot"
    @onCancel="visibleConfirmExport = false" 
    @onConfirm="handleExportHubspot"
  />
</template>

<script>
import { computed, defineComponent, inject, ref, watch } from "vue";
import { useStore } from "vuex";
import {
  DownloadOutlined,
  // ExclamationCircleOutlined,
  PlusOutlined,
  SearchOutlined,
  TableOutlined,
  FilterOutlined,
  LoadingOutlined,
  SwapOutlined,
  DownOutlined,
  EyeOutlined,
  ExportOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons-vue";
import _ from "lodash";

import ChangeStatusContactModal from "@/app/contacts/components/modal/ChangeStatusContactModal.vue";
import CreateNewContact from "@/app/contacts/components/modal/CreateNewContact.vue";
import { downloadContactByFilters, exportContactsHubspot } from "@/app/contacts/services";
import BasesPicker from "@/app/shared/components/pickers/BasesPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import ManagedAndUnmanagedPicker from "@/app/shared/components/pickers/ManagedAndUnmanagedPicker.vue";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";
import { downloadFile } from "@/app/shared/utils/file";

import { fetchContactsIdsWithBasicFilters, fetchContactsIdsWithAdvancedFilters, updateStatusContact, fetchContactsStatus } from "@/app/contacts/services"
import { message, Modal } from "ant-design-vue";
import { ProfileTypes, RolTypes } from "@/app/shared/utils/enums";
import HubspotIcon from "@/app/integrations/components/icons/HubspotIcon.vue";
import HubspotLogo from "@/app/integrations/components/icons/HubspotLogo.vue";
import httpManager from "@/app/shared/utils/httpManager";
import { HubspotIntegrationType, IntegrationMode, IntegrationModeNumber } from "@/app/integrations/utils/enums";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import ImportIcon from "@/app/common/components/icons/ImportIcon.vue";
import HubspotEventModal from "@/app/integrations/components/modals/HubspotEventModal.vue";
import { hubspotManager } from "@/app/integrations/services/HubspotManager";
import TableControlsSkeleton from "@/app/shared/components/skeletons/TableControlsSkeleton.vue";
import HubspotInfoExport from "@/app/integrations/components/modals/HubspotInfoExport.vue";
import HubspotManualModal from "@/app/integrations/components/modals/HubspotManualModal.vue";
import { createVNode } from "vue";
import HubspotExportConfirmModal from "@/app/integrations/components/modals/HubspotExportConfirmModal.vue";
import HubspotEventsPopover from "@/app/common/components/organisms/HubspotEventsPopover.vue";

export default defineComponent({
  components: {
    EntityPicker,
    CampaignPicker,
    BasesPicker,
    ManagedAndUnmanagedPicker,
    SearchOutlined,
    // ExclamationCircleOutlined,
    DownloadOutlined,
    PlusOutlined,
    CreateNewContact,
    TableOutlined,
    FilterOutlined,
    LoadingOutlined,
    ChangeStatusContactModal,
    SwapOutlined,
    HubspotIcon,
    CustomScrollbar,
    HubspotLogo,
    DownOutlined,
    EyeOutlined,
    ExportOutlined,
    ImportIcon,
    HubspotEventModal,
    TableControlsSkeleton,
    HubspotInfoExport,
    HubspotManualModal,
    QuestionCircleOutlined,
    HubspotExportConfirmModal,
    HubspotEventsPopover,
  },
  props: {
    typificationType: {
      required: false,
      type: Number,
      default: null,
    },
    selectedRows: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  setup(_, { emit }) {
    const store = useStore();
    const user = computed(() => store.getters["getDataUser"]);
    const entity = ref("");
    if (user.value) {
      if (user.value.customer.type_business == 2) {
        entity.value = 1;
      }
    }
    const eventModalVisibleImport = ref(false);
    
    const eventModalVisibleExport = ref(false);
    const eventModalVisibleInfo = ref(false);

    const { isGlobalDownloading } = useGlobalDownloadState();

    const loadingTableData = inject("loadingTableData");

    const handleOpenColumnFilterDrawer = () => {
      emit("open-column-filter-drawer", true);
    };

    watch(user, (newValue) => {
      if (newValue.customer.type_business == 2) {
        entity.value = 1;
      }
    });

    const selectedTableRowKeys = inject("selectedTableRowKeys");
    const selectedHubspotExportRowKeys = inject("selectedHubspotExportRowKeys");
    const selectedHubspotResyncRowKeys = inject("selectedHubspotResyncRowKeys");
    const rowsListMassive = inject("rowsListMassive");
    const selectedAll = inject("selectedAll");
    const countStatusSelected = inject("countStatusSelected");
    const loadingSelectMassive = ref(false);

    const selectedHubspotExportIds = computed(() => {
      return selectedHubspotExportRowKeys.value?.length > 0 ? selectedHubspotExportRowKeys.value : selectedHubspotResyncRowKeys.value
    });
    const verifyStatusRowsSelected = async () => {
      const itemsSearched = rowsListMassive.value.filter(el => selectedTableRowKeys.value.includes(el.key));
      if (itemsSearched.length == selectedTableRowKeys.value.length) {
        const actives = itemsSearched.filter(el => el.status == 1);
        const inactives = itemsSearched.filter(el => el.status == 2);
        countStatusSelected.value.actives = actives.length;
        countStatusSelected.value.inactives = inactives.length;
      } else {
        loadingSelectMassive.value = true;
        const response = await fetchContactsStatus(selectedTableRowKeys.value);
        countStatusSelected.value.actives = response.number_active_clients;
        countStatusSelected.value.inactives = response.number_inactive_clients;
        loadingSelectMassive.value = false;
      }
    };

    const handleDeselectedAll = () => {
      selectedTableRowKeys.value = [];
    }

    watch(
      selectedTableRowKeys,
      async () => {
        await verifyStatusRowsSelected();
      },
      { deep: true }
    );

    const onMenuClick = (e) => {
      emit("action", e.key); 
      if(e.key === "info"){
        eventModalVisibleInfo.value = true;
      } else if(e.key === "import"){
        eventModalVisibleImport.value = true;
      } else if(e.key === "export"){
        eventModalVisibleExport.value = true;
      }
    };

    return {
      entity,
      user,
      isGlobalDownloading,
      loadingTableData,
      selectedTableRowKeys,
      selectedHubspotExportRowKeys,
      selectedHubspotResyncRowKeys,
      rowsListMassive,
      selectedAll,
      countStatusSelected,
      loadingSelectMassive,
      handleDeselectedAll,
      handleOpenColumnFilterDrawer,
      ProfileTypes,
      onMenuClick,
      HubspotIntegrationType,
      eventModalVisibleImport,
      eventModalVisibleExport,
      eventModalVisibleInfo,
      selectedHubspotExportIds,
    };
  },
  data() {
    return {
      search: "",
      // entity: 0,
      campaign: 0,
      base: 0,
      coverage: 0,
      status: '',
      createContactModalVisible: false,
      downloading: false,
      // loadingSelectMassive: false,
      visibleAlertInactiveContact: false,
      statusChange: null,

      visibleMoreFilters: false,
      formDrawer: {
        entity: null,
        campaign: null,
        base: null,
        coverage: null,
        status: null,
      },
      countLoading: 0,
      countFilterLoading: 4,
      visibleConfirmExport: false,
      actionHubspot: null,
      loadingSaveHubspot: false,
    };
  },
  computed: {
    basicFilters() {
      return this.$store.getters["getBasicFilters"];
    },
    filterAdvanced() {
      return this.$store.getters["getFilterAdvanced"];
    },
    contactsInfo() {
      return this.$store.getters["getContactsInfoTable"];
    },
    getUserData() {
      return this.$store.getters["getDataUser"];
    },
    isAgentUser() {
      return this.getUserData?.role?.id === RolTypes.agent;
    },
    hasHubspotActive() {
      return this.$store.getters["hasHubspotActive"];
    },
    hasHubspotExport() {
      console.log("hubspot_type", HubspotIntegrationType.Export);
      return this.$store.getters.hasHubspotByCode(HubspotIntegrationType.Export);
    },
    hasHubspotImport() {
      return this.$store.getters.hasHubspotByCode(HubspotIntegrationType.Import);
    },
    hasHubspotExportManual() {
      const functionality = this.$store.getters.getHubspotByCode(HubspotIntegrationType.Export);
      if (functionality)
        return functionality.mode == IntegrationModeNumber[IntegrationMode.Manual];
      return false;
    }
  },
  watch: {
    search: _.debounce(function () {
      this.handleSearch();
    }, 500),
    entity() {
      // this.$emit("onSelectEntityId", this.entity);
      this.handleSearch();
    },
    campaign() {
      // this.$emit("onSelectCampaignId", this.campaign);
      this.handleSearch();
    },
    base() {
      // this.$emit("onSelectBaseId", this.base);
      this.handleSearch();
    },
    coverage() {
      this.handleSearch();
    },
    status() {
      this.handleSearch();
    },
    typificationType() {
      this.handleSearch();
    },
  },
  methods: {
    redirectIntegration(){
      this.$router.push("/channels/integrations");
    },
    async handleEventSave(payload) {
      try {
        const { formState, type } = payload;
        const response = await hubspotManager.saveHubspotEvent({
          code: type,
          event: {
            id: formState.id,
            scheduled: formState.scheduled ?? null,
            contacts: formState.contacts ?? [],
            portfolios: formState.portfolio ?? [],
            entities: formState.entity ?? [],
          }
        });
        console.log(response, 'response')
        message.success(response.message);
        this.eventModalVisibleImport = false;
      } catch (error) {
        const messageError = error?.getErrorMessage?.() || "Ha ocurrido un error";

        message.error(messageError);
      }
    },
    async handleSearch() {
      this.loadingTableData = true;

      const entitySelected = this.entity === 0 ? "0" : this.entity;
      const campaignSelected = this.campaign === 0 ? "0" : this.campaign;

      // if (entitySelected === 0) {
      //   entitySelected = "0";
      // }
      // if (campaignSelected === 0) {
      //   campaignSelected = "0";
      // }

      this.resetSelectTable();
      
      const filters = {
        search: this.search,
        entity: this.entity,
        campaign: this.campaign,
        base: this.base,
        typification_type: this.typificationType,
        coverage: this.coverage,
        status: this.status,
      };
      // const filtersAdvanced = {
      //   search: this.search,
      //   entity: entitySelected,
      //   campaign: campaignSelected,
      //   base: this.base,
      //   typification_type: this.typificationType,
      //   coverage: this.coverage,
      // };

      this.$store.commit("SET_BASIC_FILTERS", filters);
      if (filters.coverage && entitySelected && campaignSelected) {
        await this.$store.dispatch("fetchAdvancedFilters", {
          ...filters,
          entity: entitySelected,
          campaign: campaignSelected,
        });
      }
      await this.$store.dispatch("fetchContacts", { filters: filters, pagination: { current: 1 } });
      this.$store.commit("SET_CURRENT_TABLE_PAGE", 1);
      // await this.$store.dispatch("applyAdvancedFilters", {
      //   filters: filters,
      //   pagination: { current: 1 },
      // });

      this.rowsListMassive = this.contactsInfo.items.map(el => ({ key: el.key, page: 1, status: el.status }))

      this.loadingTableData = false;

      this.$store.commit("SET_CURRENT_TABLE_PAGE", 1);
    },
    async handleSelectedAll() {
      // console.log(advancedFilters.value, 'advancedFilters.value')
      this.loadingSelectMassive = true;
      console.log(Object.keys(this.filterAdvanced));
      if (Object.keys(this.filterAdvanced)) {
        const response = await fetchContactsIdsWithBasicFilters(this.basicFilters);
        this.selectedTableRowKeys = response.ids;
        this.selectedHubspotExportRowKeys = response.ids_without_hubspot;
        this.selectedHubspotResyncRowKeys = response.ids_resync_hubspot || 0;
      } else {
        const response = await fetchContactsIdsWithAdvancedFilters({
          ...this.basicFilters,
          ...this.filterAdvanced,
        });
        this.selectedTableRowKeys = response.ids;
        this.selectedHubspotExportRowKeys = response.ids_without_hubspot;
        this.selectedHubspotResyncRowKeys = response.ids_resync_hubspot || 0;
      };
      this.loadingSelectMassive = false;
    },
    openCreateContactModal() {
      this.createContactModalVisible = true;
    },
    handleOpenAdvanceFilter() {
      this.$emit("onOpenAdvanceFilter");
    },
    async handleDownload() {
      this.downloading = true;

      let filters = {
        search: this.search,
        entity: this.entity,
        campaign: this.campaign,
        base: this.base,
        coverage: this.coverage,
        status: this.status,
      };
      if (this.selectedTableRowKeys.length > 0) {
        filters.contacts_ids = this.selectedTableRowKeys;
      }
      const response = await downloadContactByFilters(filters);
      downloadFile(response, "Contactos.xlsx", { useResponseFileName: true });

      this.downloading = false;
    },
    resetSelectTable() {
      this.selectedTableRowKeys = [];
      this.selectedHubspotExportRowKeys = [];
      this.rowsListMassive = [];
      this.selectedAll = false;
    },
    showModalChangeStatus(status) {
      this.visibleAlertInactiveContact = true;
      this.statusChange = status;
    },
    async handleUpdateStatus(status) {
      try {
        const response = await updateStatusContact(this.selectedTableRowKeys, status);
        message.warning(response.data?.message);
        this.resetSelectTable();
        // this.$store.dispatch('fetchContactsExtern');
        // this.handleSearch();
      } catch(error) {
        message.error(error.getErrorMessage());
      }
    },
    handleConfirmExportHubspot(){
      this.visibleConfirmExport = true;
      this.actionHubspot = 'export';
    },
    async handleExportHubspot() {
      try {
        this.loadingSaveHubspot = true;
        // const response = await exportContactsHubspot(this.selectedTableRowKeys);
        console.log(this.selectedHubspotExportIds, 'selectedHubspotExportRowKeys');
        const response = await exportContactsHubspot(this.selectedHubspotExportIds);
        if (this.actionHubspot === 'export')
          message.success(`Se ha iniciado la exportación de ${this.selectedHubspotExportRowKeys.length} contactos a HubSpot.`);
        else
          message.success(`Se ha iniciado la actualización de ${this.selectedHubspotExportRowKeys.length} contactos a HubSpot.`);
        this.resetSelectTable();
        this.visibleConfirmExport = false;
        this.actionHubspot = null;
        // this.$store.dispatch('fetchContactsExtern');
        // this.handleSearch();
      } catch(error) {
        message.error(error?.getErrorMessage?.());
      } finally {
        this.loadingSaveHubspot = false;
      }
    },
    handleMoreFilters() {
      this.visibleMoreFilters = true;
      this.formDrawer = {
        entity: this.entity,
        campaign: this.campaign,
        base: this.base,
        coverage: this.coverage,
        status: this.status,
      }
    },
    handleClearDrawer() {
      this.formDrawer = {
        entity: '',
        campaign: 0,
        base: 0,
        coverage: 0,
        status: '',
      }
    },
    handleApplyFilters() {
      this.entity = this.formDrawer.entity;
      this.campaign = this.formDrawer.campaign;
      this.base = this.formDrawer.base;
      this.coverage = this.formDrawer.coverage;
      this.status = this.formDrawer.status;
      this.visibleMoreFilters = false;
    },
  },
});
</script>

<style lang="sass" scoped>
.form-item__advanced-filter
  margin-right: 0px !important

.all__contact
  display: flex

.container__picker
  width: 180px
  &--drawer
    width: 100%

:global(.container__picker--drawer .select)
      width: 100% !important

.section_flex
  display: flex
  justify-content: space-between
  margin-bottom: 10px
  align-items: center

.flex
  display: flex
  justify-content: space-between

:deep(.ant-input)
  cursor: pointer

.actions
  position: relative
  display: flex
  align-items: center
  justify-content: center
  gap: 8px
  .total
    position: absolute
    right: 0
    top: -32px
    color: $gray-9
    text-align: right
    width: 250px

.button
  &.create
    margin-right: 8px

.multiselect-row
  text-align: center

  .counter
    color: $gray-8
    background-color: $geekblue-4
    padding: 4px 0

  .actions
    background-color: $geekblue-1
    padding: 3px 0

  .divider
    background-color: $text-secondary
    height: 1.5em

.hubspot-icon
  gap: 8px
  margin-right: 15px
.fake-link 
  color: #1677ff
  cursor: pointer

.fake-link:focus
  outline: none

.modal
  &__body
    margin: 12px 24px

.footer
  display: flex
  align-items: center
  justify-content: flex-end
  margin-top: 8px
  padding: 12px 16px
  border-top: $border-normal

  &__display
    width: 100%
    font-size: 12px
    color: $gray-7

  &__button
    margin-right: 12px

.drawer__body
  &--title
    font-weight: 600
    color: $gray-9

  &--subtitle
    font-weight: 400
    color: $gray-8
.hs-select 
  height: 32px
  border-radius: 6px
  padding: 0 10px
  display: inline-flex
  align-items: center
  justify-content: space-between
  gap: 10px

.hs-select:hover
  border: 2px solid #ff7a59

.hs-select__left 
  display: inline-flex
  align-items: center
  gap: 8px


.hs-select__label 
  font-weight: 600


.hs-select__caret 
  font-size: 12px
  opacity: 0.8


.hs-menu 
  border-radius: 12px
  overflow: hidden
  padding: 6px
  min-width: 220px

.hs-select-dropdown
  display: flex

:deep(.ant-dropdown-menu-item) 
  border-radius: 10px
  gap: 10px

.hs-menu-item
  padding-right: 8px
.menu-icon
  margin-right: 8px
.tree-skeleton
  display: flex
  flex-direction: column
  gap: 12px
  margin-top: 10px
  &__bar
    height: 12px
    border-radius: 5px
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)
    background-size: 400% 100%
    animation: skeleton-loading 1.4s ease infinite
    margin: 2px 0
    width: 200px !important
</style>
